import React from 'react'
import { useTranslate } from 'react-admin'
import { TableCell, Typography } from '@mui/material'
import { isStatus } from 'src/components/pages/sales/reservation/helper/isStatus'

interface StatusTableCellProps {
  data: string
}

export const StatusTableCell: React.FC<StatusTableCellProps> = ({ data }) => {
  const translate = useTranslate()
  let status = data ? data : 'UNPAID' // Default to 'UNPAID' if no status is found
  status = status === 'PENDING' ? 'PENDING_BILLING' : status

  return (
    <TableCell style={{ padding: '0px 16px' }}>
      <Typography style={status ? { ...isStatus('status', status, true) } : undefined}>
        {translate(`ra.status.${status}`).includes('.') ? status : translate(`ra.status.${status}`)}
      </Typography>
    </TableCell>
  )
}
